import React from 'react';
import { HStack, Text, Box, useColorModeValue } from '@chakra-ui/react';
import { Button } from 'src/components/atoms/Button';
import { Icon } from 'src/components/atoms/Icon';
import { BulkAction } from 'src/api/users';

type BulkActionsBarProps = {
  selectedCount: number;
  onBulkAction: (action: BulkAction) => void;
  onClearSelection: () => void;
  isLoading: boolean;
  hasPendingUsers: boolean;
};

export const BulkActionsBar: React.FC<BulkActionsBarProps> = ({
  selectedCount,
  onBulkAction,
  onClearSelection,
  isLoading,
  hasPendingUsers,
}) => {
  const barBg = useColorModeValue('blue.50', 'rgba(30, 136, 229, 0.15)');
  const deleteHoverBg = useColorModeValue('red.50', 'rgba(212, 62, 56, 0.2)');

  if (selectedCount === 0) return null;

  return (
    <Box bg={barBg} p={3} borderRadius="md" mb={4}>
      <HStack justify="space-between">
        <Text fontWeight="medium">
          {selectedCount} user{selectedCount > 1 ? 's' : ''} selected
        </Text>
        <HStack spacing={2}>
          {hasPendingUsers && (
            <Button
              size="sm"
              bg="surface.panel"
              color="content.title"
              border="1px solid"
              borderColor="icon.green"
              onClick={() => onBulkAction('resend_invites')}
              isLoading={isLoading}
              buttonName="bulk-resend"
              _hover={{ bg: 'border.lightGreen' }}>
              <Icon iconName="refresh" boxSize={4} mr={2} />
              Resend Invites
            </Button>
          )}
          <Button
            size="sm"
            bg="surface.panel"
            color="red.500"
            border="1px solid"
            borderColor="red.500"
            onClick={() => onBulkAction('delete')}
            isLoading={isLoading}
            buttonName="bulk-delete"
            _hover={{ bg: deleteHoverBg }}>
            <Icon iconName="trash" boxSize={4} mr={2} />
            Delete
          </Button>
          <Button
            size="sm"
            variant="ghost"
            onClick={onClearSelection}
            buttonName="clear-selection">
            Clear
          </Button>
        </HStack>
      </HStack>
    </Box>
  );
};
